
import { mmMatches } from '../utils/utils.matchmedia';

const 	$ = jQuery;

const 	$recipe_tabs = $('.js-recipe-tabs'),
		$tab = $recipe_tabs.find( $('.js-single-recipe-tab') );

let 	$tab_button = null;

if ( $recipe_tabs.length ) {

	single_recipe_tabs_init();

}

function single_recipe_tabs_init () {

	$tab.addClass('can-toggle')

	$recipe_tabs.before(`<div class="single-recipe-tabs mb-m">
								<button class="single-recipe-tabs__primary ptb-s fs-m js-toggle-tab js-primary-toggle">
									Ingredients
								</button>
								<button class="single-recipe-tabs__secondary ptb-s fs-m js-toggle-tab js-secondary-toggle">
									Method
								</button>
							</div>`);

	$tab_button = $('.js-toggle-tab');

	const 	$primary_button = $('.js-primary-toggle'),
			$secondary_button = $('.js-secondary-toggle'),
			$primary_tab = $recipe_tabs.find( $('.js-single-recipe-tab-primary') ),
			$secondary_tab = $recipe_tabs.find( $('.js-single-recipe-tab-secondary') );

	$primary_button.on('click', function () {

		show_target_tab( $(this), $primary_tab );

	});

	$secondary_button.on('click', function () {

		show_target_tab( $(this), $secondary_tab );

	});

	if ( !mmMatches( 'tablet' ) ) {
		
		$primary_button.click();

	}

}

function show_target_tab ( clicked_element, target_element ) {

	if ( !target_element.hasClass( 'active' ) && !clicked_element.hasClass( 'active' ) ) {

		$tab_button.removeClass('active');
		$tab.removeClass('active');

		clicked_element.addClass('active');
		target_element.addClass('active');

	}

}